/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Manual_Qc_Linked_EventsInputs */

const en_manual_qc_linked_events = /** @type {(inputs: Manual_Qc_Linked_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Will be linked to ${i?.count} selected event(s)`)
};

const fr_manual_qc_linked_events = /** @type {(inputs: Manual_Qc_Linked_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sera lie a ${i?.count} evenement(s) selectionne(s)`)
};

const de_manual_qc_linked_events = /** @type {(inputs: Manual_Qc_Linked_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wird mit dem/den ausgewählten Ereignis(sen) ${i?.count} verknüpft`)
};

const it_manual_qc_linked_events = /** @type {(inputs: Manual_Qc_Linked_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sarà collegato a ${i?.count} eventi selezionati`)
};

const ru_manual_qc_linked_events = /** @type {(inputs: Manual_Qc_Linked_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Будет связано с выбранным(и) событием(ями) ${i?.count}`)
};

const es_manual_qc_linked_events = /** @type {(inputs: Manual_Qc_Linked_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se vinculará a ${i?.count} eventos seleccionados`)
};

const zh_cn2_manual_qc_linked_events = /** @type {(inputs: Manual_Qc_Linked_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`将与 ${i?.count} 选定的事件关联`)
};

const pt_pt2_manual_qc_linked_events = /** @type {(inputs: Manual_Qc_Linked_EventsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Será vinculado ao(s) evento(s) selecionado(s) ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Will be linked to {count} selected event(s)" |
*
* @param {Manual_Qc_Linked_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_linked_events = /** @type {((inputs: Manual_Qc_Linked_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Linked_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_linked_events(inputs)
	if (locale === "de") return de_manual_qc_linked_events(inputs)
	if (locale === "it") return it_manual_qc_linked_events(inputs)
	if (locale === "ru") return ru_manual_qc_linked_events(inputs)
	if (locale === "es") return es_manual_qc_linked_events(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_linked_events(inputs)
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントにリンクされます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटना(ओं) से लिंक किया जाएगा")
	if (locale === "pt-PT") return pt_pt2_manual_qc_linked_events(inputs)
	return en_manual_qc_linked_events(inputs)
});